{
  "hubspot": {
    "lifecycleStage": {
      "subscriber": "Abonné",
      "lead": "Lead",
      "marketingQualifiedLead": "Lead qualifié marketing",
      "salesQualifiedLead": "Lead qualifié commercial",
      "opportunity": "Opportunité",
      "customer": "Client",
      "leadForLater": "Lead pour plus tard",
      "partnerLead": "Lead partenaire"
    },
    "leadStatus": {
      "new": "Nouveau",
      "open": "Ouvert",
      "inProgress": "En cours",
      "openDeal": "Affaire ouverte",
      "attemptedToContact": "Tentative de contact",
      "connected": "Connecté",
      "badTiming": "Mauvais timing",
      "meeting": "Rendez-vous fixé",
      "qualified": "Qualifié",
      "unqualified": "Non qualifié",
      "firstEmail": "Premier e-mail envoyé",
      "firstEmailFollowUp1": "Premier e-mail | 1ʳᵉ relance",
      "firstEmailFollowUp2": "Premier e-mail | 2ᵉ relance",
      "appointmentScheduled": "Rendez-vous planifié",
      "notSuitable": "Non pertinent",
      "noConcretization": "Pas de concrétisation"
    },
    "relationship": {
      "b2bLicense": "Licence B2B (pour clients finaux)",
      "partnerLicenseWithoutSeats": "Licence partenaire (sans sièges)",
      "partnerLicenseWithSeats": "Licence partenaire (avec sièges)",
      "internationalPartnerLicenseWithSeat": "Licence partenaire internationale (avec siège)",
      "internationalPartnerLicenseWithoutSeat": "Licence partenaire internationale (sans siège)",
      "internationalB2bLicenseEndUser": "Licence B2B internationale (client final)",
      "externalWorkforceProductDevelopment": "Main-d’œuvre externe pour le développement produit",
      "communityCatalyst": "Community Catalyst",
      "technicalIntegrationPartner": "Partenaire d’intégration technique"
    }
  }
}
